<template>
  <button
    class="btn"
    type="button"
    :class="{ loading, disabled, 'has-badge': badge !== 0 }"
    @click.stop="!loading && !disabled ? emits('click') : null"
  >
    <slot name="prefix"></slot>
    <span v-if="label !== 'default'">{{ label }}</span>
    <span v-if="loading" class="bi bi-arrow-repeat" />
    <i v-if="icon && !loading" :class="icon" class="main-icon" />
    <div v-if="badge !== 0" class="badge">{{ badge }}</div>
  </button>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";
.has-badge {
  position: relative;
}

.badge {
  position: absolute;
  top: 0;
  left: 100%;

  transform: translate(-8px, -8px);

  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  
  font-size: 10px;
  line-height: 16px;

  border-radius: 100%;
  color: $secondary-color;
  background-color: $primary-color;
}
</style>

<script setup>
const emits = defineEmits(["click"]);

defineProps({
  label: {
    type: String,
    default: "default",
  },
  icon: {
    type: String,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  badge: {
    type: Number,
    default: 0,
  },
});
</script>